<template>
  <div class="process-item" :class="{ 'all-item': name === 'All' }">
    <span class="process-title">{{ $t(name) }}</span>
    <div class="process-icon">
      <v-checkbox
        v-if="selection"
        class="process-checkbox"
        :ripple="false"
        v-model="checked"
        color="accent"
        :disabled="
          (name !== 'All' && !userHasFibercloudPermission(permissionName)) ||
          (name === 'All' && allCheckboxIsDisabled)
        "
      />
      <v-progress-circular
        v-if="run && loading && name !== 'All'"
        indeterminate
        size="15"
        width="2"
        color="accent"
        class="process-item-icon"
      />

      <v-icon
        v-show="name !== 'All' && checked && complete === 'success'"
        color="success"
        class="process-item-icon"
      >
        check_circle
      </v-icon>

      <v-icon
        v-show="name !== 'All' && checked && complete === 'failure'"
        color="error"
        class="process-item-icon"
      >
        error
      </v-icon>
    </div>
  </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "process",

  components: { ClipLoader },

  mixins: [checkPermissionsMixin],

  props: {
    /** Name of the process */
    name: {
      type: String,
      required: true
    },
    /** If the process is selected or not */
    selected: {
      type: Boolean
    },
    /** If the process is running or not */
    loading: {
      type: Boolean
    },
    /** If the process is complete or not */
    complete: {
      type: String
    },
    /** If the Calculations is in the Selection phase or not */
    selection: {
      type: Boolean
    },
    /** If the Calculations is in the Run phase or not */
    run: {
      type: Boolean
    },
    /** Permission to execute the calculation */
    permissionName: {
      type: String
    },
    /**
     * Determines if the 'All' checkbox is disabled
     */
    allCheckboxIsDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      /** Value of the checkbox. */
      checked: false,
      /** Color of the process loading spinner. */
      spinnerColor: "var(--primary-highlight)",
      /** Size of the process loading spinner. */
      spinnerSize: "15px"
    };
  },

  watch: {
    /**
     * Sends to the parent component the new 'checked' value if the process checkbox is toggled.
     * @param {boolean} value
     */
    checked(value) {
      this.$emit("toggle", value);
    },

    /**
     * Updated the 'checked' value if the parent sends a new 'selected' value
     * @param value
     */
    selected(value) {
      this.checked = value;
    }
  }
};
</script>

<style scoped>
.process-item {
  width: 100%;
  height: 25px;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.all-item {
  height: 40px;
}

.all-item .process-title {
  margin-left: 10px;
  font-weight: 400;
}
.process-title {
  margin-left: 20px;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.03px;
}

.process-item-icon {
  margin: 0 15px;
}
</style>
<style>
.process-checkbox .theme--light.v-icon {
  margin-top: 5px;
  font-size: 18px;
}
.all-item .process-checkbox .theme--light.v-icon {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/Calculations/ProcessItem.vue